var map = {
	"./badge.png": 127,
	"./badge1.png": 6246,
	"./badge2.png": 3277,
	"./badge3.png": 772,
	"./badge4.png": 715,
	"./badge5.png": 1714,
	"./badge6.png": 505,
	"./badge7.png": 5680,
	"./badge8.png": 9303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1765;